import React from 'react';
import { Outlet } from 'react-router-dom';

const ShareableLinksRouter: React.FC = () => <Outlet />;

export default ShareableLinksRouter;
